import React, { useState } from 'react';

const TravelInsurance = () => {
  const [insurancePolicies, setInsurancePolicies] = useState([
    { id: 1, name: 'John Doe', phone: '(555) 123-4567', email: 'john.doe@example.com', policyType: 'Premium', coverage: '$500,000', status: 'Active' },
  ]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [newPolicy, setNewPolicy] = useState({
    name: '',
    email: '',
    phone: '',
    policyType: 'Basic',
    coverage: '',
    status: 'Pending'
  });

  const handleInitiateInsurance = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setNewPolicy({
      name: '',
      email: '',
      phone: '',
      policyType: 'Basic',
      coverage: '',
      status: 'Pending'
    });
  };

  const handleAddPolicy = () => {
    // Validate form
    if (!newPolicy.name || !newPolicy.email || !newPolicy.phone || !newPolicy.coverage) {
      alert('Please fill in all required fields');
      return;
    }
    
    // Add new policy to the list
    const newPolicyWithId = {
      id: insurancePolicies.length + 1,
      ...newPolicy
    };
    
    setInsurancePolicies([...insurancePolicies, newPolicyWithId]);
    closePopup();
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-[#02385E] font-Montserrat">Travel Insurance Services</h1>
        <button
          onClick={handleInitiateInsurance}
          className="px-4 py-2 text-white font-semibold rounded-full flex items-center gap-2"
          style={{ background: 'linear-gradient(180deg, #FFA782 0%, #FC583D 100%)', }}  >
          <span style={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: '500', lineHeight: '24.38px', }}>            
            Purchase Insurance
          </span>
          <img src={`${process.env.PUBLIC_URL}/images/desktop/staffadd.svg`} alt="Add Insurance Icon" className="w-4 h-4 ml-2" />
        </button>
      </div>

      <div className="rounded-xl overflow-hidden bg-white shadow-lg">
        <div className="overflow-x-auto relative">
          <table className="min-w-full table-auto border-collapse">
            <thead>
              <tr className="bg-gradient-to-r from-[#02385E] to-[#02385E]/90">
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Name</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Phone</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Email</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Policy Type</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Coverage</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider border-r border-[#ffffff20] font-Montserrat">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {insurancePolicies.map((policy, index) => (
                <tr key={policy.id} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={policy.name}>{policy.name}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={policy.phone}>{policy.phone}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={policy.email}>{policy.email}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={policy.policyType}>{policy.policyType}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <div className="truncate text-left" title={policy.coverage}>{policy.coverage}</div>
                  </td>
                  <td className="px-4 py-2.5 whitespace-nowrap border-r border-gray-100 text-neutral-600 text-left font-Montserrat">
                    <span className={`inline-block min-w-[80px] px-2 py-1 rounded-full ${
                      policy.status === 'Active' ? 'bg-green-100 text-green-800' :
                      policy.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                      policy.status === 'Processing' ? 'bg-blue-100 text-blue-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {policy.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Insurance Policy Popup */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-3xl w-[90%] md:w-[70%] lg:w-[50%] relative">
            <div className="top-0 left-0 right-0 h-[40px] flex items-center justify-between rounded-tl-[12px] rounded-tr-[12px] p-4">
              <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-gradient-to-b from-[#00A6D9] to-[#3483BE] flex items-center justify-center">
                  <img src={`${process.env.PUBLIC_URL}/images/desktop/ph_student.svg`} alt="Student Icon" />
                </div>
                <h2 className="text-xl font-semibold text-black">Purchase Travel Insurance</h2>
              </div>
              <div className="text-right">
                <button onClick={closePopup} className="absolute top-4 right-4 font-semibold text-3xl" style={{ background: 'linear-gradient(270deg, #A7C8E7 0%, #00A6D9 100%)', WebkitBackgroundClip: 'text', color: 'transparent', }}>
                  <img src={`${process.env.PUBLIC_URL}/images/desktop/close-btn.svg`} alt="Close" className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-8">
              <div>
                <label className="block text-sm font-medium text-gray-700">Name <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={newPolicy.name}
                  onChange={(e) => setNewPolicy({ ...newPolicy, name: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={newPolicy.email}
                  onChange={(e) => setNewPolicy({ ...newPolicy, email: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Phone <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={newPolicy.phone}
                  onChange={(e) => setNewPolicy({ ...newPolicy, phone: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Policy Type</label>
                <select
                  value={newPolicy.policyType}
                  onChange={(e) => setNewPolicy({ ...newPolicy, policyType: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                >
                  <option value="Basic">Basic</option>
                  <option value="Standard">Standard</option>
                  <option value="Premium">Premium</option>
                  <option value="Comprehensive">Comprehensive</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Coverage Amount <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Coverage (e.g., $500,000)"
                  value={newPolicy.coverage}
                  onChange={(e) => setNewPolicy({ ...newPolicy, coverage: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Status</label>
                <select
                  value={newPolicy.status}
                  onChange={(e) => setNewPolicy({ ...newPolicy, status: e.target.value })}
                  className="border p-2 w-full mb-2"
                  style={{ borderRadius: '24px', border: '1px solid #3483BE' }}
                >
                  <option value="Pending">Pending</option>
                  <option value="Processing">Processing</option>
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </div>

            <div className="mt-8 flex justify-end">
              <button 
                onClick={handleAddPolicy} 
                className="px-8 py-2 bg-gradient-to-b from-[#FFA782] to-[#FC583D] text-white rounded-3xl"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TravelInsurance;